import BlankContent from '@components/blank/BlankContent';
import Column from '@components/Column';

import usePointCards from './hooks/usePointCards';
import PointLog from './PointLog';
import styles from './styles.module.scss';

function PointLogs() {
    const pointCards = usePointCards();
    return (
        <Column className={styles.container}
            fullWidth
            spacing={16} >
            {(pointCards?.length === 0) && (
                <BlankContent/>
            ) }
            {pointCards?.map((pointCard) => (
                <PointLog pointCard={pointCard}
                    key={pointCard.shopId}
                />))}
        </Column>
    );
}

export default PointLogs;
